export default function Loading() {
  // Scroll to the top so that the footer is below the fold and doesn't add to CLS
  document.documentElement.scrollTop = 0;

  return (
    <div
      className="d-flex align-items-center justify-content-center flex-column flex-wrap flex-grow-1 vh-100"
      data-testid="loading"
    >
      <div className="spinner spinner-1" />
      <p className="lead">Loading</p>
    </div>
  );
}
